import React, {useContext} from "react";
import {View, Text} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import {PrintDocumentContext} from "./printDocumentContext";
import {DISCOUNT_SECTION_TYPES, DISCOUNT_FINANCE_CELLS} from "../../priceWorksheet/discounstInterface";
import {calculateCellValue} from "../../priceWorksheet/discountFunctions";

const PrintDocumentDiscountFinance = (props) => {
  const {styles, discount, priceWorksheetState, fabricatorSettings, grandTotal} = props;
  const {discountSections, financePercentage, financeCellsVisible} = priceWorksheetState;

  const printContext = useContext(PrintDocumentContext);

  const financeSection = discountSections.find(sec => sec.type === DISCOUNT_SECTION_TYPES.finance);
  if (!financeSection) {
    return null;
  }

  let parsedOptions = typeof discount.financeOptions === "string"
    ? JSON.parse(discount.financeOptions)
    : [];

  return (
    <View style={styles.cartItem} wrap={false}>
      <View style={styles.marginT5}>
        <View>
          <Text style={[styles.gray, styles.bold]}>
            {printContext.messages["shoppingCart.discounts.financeTitle"]}
          </Text>
        </View>
        <View style={[styles.flex, styles.flexRow, styles.flexCenter]}>
          <Text style={styles.gray}>
            {printContext.messages["shoppingCart.discounts.financeSubTitle"]}
          </Text>
          <Text style={[styles.gray, styles.bold, styles.discountPercent]}>
            {priceWorksheetState.financePercentage + "%"}
          </Text>
        </View>
      </View>
      <View style={[styles.flex, styles.width100, styles.flexRow, styles.marginT5, styles.marginB5]}>
        {Object.keys(DISCOUNT_FINANCE_CELLS).map((property, propertyIndex) => {
          const cellStyles = propertyIndex === 1
            ? [styles.financeCell, styles.marginL10, styles.marginR10]
            : styles.financeCell;
          const selectedDiscount = financeSection.discounts.find(dis => dis.uuId === parsedOptions[propertyIndex]);
          return (
            <View style={cellStyles} key={property}>
              <Text>
                {selectedDiscount
                  ? selectedDiscount.financeMonths + " " + printContext.messages["shoppingCart.discounts.months"]
                  : null}
              </Text>
              <View style={[styles.flex, styles.width100, styles.flexCenter, styles.marginT8, styles.marginB16]}>
                <Text style={[styles.active, styles.financeCellText]}>
                  {financeCellsVisible ? calculateCellValue(
                    {discountSections, financePercentage, fabricatorSettings},
                    selectedDiscount ? selectedDiscount.financeMonths : 0,
                    grandTotal,
                  ) : null}
                </Text>
              </View>
            </View>
          )
        })}
      </View>
    </View>
  )
};

PrintDocumentDiscountFinance.propTypes = {
  discount: PropTypes.object.isRequired,
  priceWorksheetState: PropTypes.object.isRequired,
  discountSection: PropTypes.object.isRequired,
  fabricatorSettings: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentDiscountFinance
